/**
 * @generated SignedSource<<82022e7005b42043d13e7a87351fce84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnsubscribeMutation$variables = {
  id: string;
};
export type UnsubscribeMutation$data = {
  readonly unsubscribeUser: {
    readonly id: string;
  } | null;
};
export type UnsubscribeMutation = {
  response: UnsubscribeMutation$data;
  variables: UnsubscribeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "unsubscribeUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnsubscribeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnsubscribeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9511424e3f54f6b3efe6bce34113d06d",
    "id": null,
    "metadata": {},
    "name": "UnsubscribeMutation",
    "operationKind": "mutation",
    "text": "mutation UnsubscribeMutation(\n  $id: String!\n) {\n  unsubscribeUser(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "05fd1752d9cb364f9544b4826b673728";

export default node;
